import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type"];
import React from 'react';
import PropTypes from 'prop-types';
import { AvailableIcon, UnavailableIcon, ClockIcon, CalendarIcon, PartialIcon } from '@sainsburys-tech/bolt-icons';

var AvailabilityIcon = function AvailabilityIcon(_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  switch (type) {
    case 'tick':
      return /*#__PURE__*/React.createElement(AvailableIcon, _extends({
        fill: "#008844",
        width: "20",
        height: "20"
      }, props));

    case 'clock':
      return /*#__PURE__*/React.createElement(ClockIcon, _extends({
        fill: "#008844",
        width: "20",
        height: "20"
      }, props));

    case 'calendar':
      return /*#__PURE__*/React.createElement(CalendarIcon, _extends({
        fill: "#008844",
        width: "20",
        height: "20"
      }, props));

    case 'triangle':
      return /*#__PURE__*/React.createElement(PartialIcon, _extends({
        fill: "#FF9600",
        width: "20",
        height: "20"
      }, props));

    case 'out_of_stock':
      return /*#__PURE__*/React.createElement(UnavailableIcon, _extends({
        fill: "#C7390E",
        width: "20",
        height: "20"
      }, props));

    default:
      return null;
  }
};

AvailabilityIcon.propTypes = {
  type: PropTypes.oneOf(['tick', 'clock', 'calendar', 'triangle', 'out_of_stock'])
};
AvailabilityIcon.defaultProps = {
  type: null
};
export default AvailabilityIcon;